import ApiClient from './ApiClient';
import PortOpeningRequestSiteToSiteOnPrem from '../models/entities/PortOpeningRequestSiteToSiteOnPrem';
import SubmitOnPremSiteToSiteVPNRequest from '../models/viewModels/OnPremSiteToSiteVPNRequests/SubmitOnPremSiteToSiteVPNRequest';
import CompletePortOpeningRequestOnPrem from '../models/viewModels/OnPremPortOpeningRequests/CompletePortOpeningRequestOnPrem';
import ReviewReason from '../models/interfaces/ReviewReason'
import NetworkConnection from '../models/entities/NetworkConnection';
import RejectionModel from '../models/interfaces/RejectionModel';
import CancellationReason from '../models/interfaces/CancellationReason';
import UpdateOnPremS2SRequest from '../models/viewModels/OnPremSiteToSiteVPNRequests/UpdateOnPremS2SRequest';

export default class OnPremPORSiteToSiteVPNService extends ApiClient {
	async getMyRequests() {
		return this.get<PortOpeningRequestSiteToSiteOnPrem[]>('OnPremS2SvpnRequests/me');
	}

	async getAll() {
		return this.get<PortOpeningRequestSiteToSiteOnPrem[]>('OnPremS2SvpnRequests');
	}

	async getMyApprovals() {
		return this.get<PortOpeningRequestSiteToSiteOnPrem[]>('OnPremS2SvpnRequests/myApprovals');
	}

	async create(request: SubmitOnPremSiteToSiteVPNRequest) {
		return this.post<PortOpeningRequestSiteToSiteOnPrem>('OnPremS2SvpnRequests', request);
	}

	async getStandardConfigurationOptions() {
		return this.get<any>('OnPremS2SvpnRequests/options');
	}

	async getById(id: number) {
		return this.get<PortOpeningRequestSiteToSiteOnPrem>(`OnPremS2SvpnRequests/${id}`);
	}

	async getNCDBbyTrackerId(trackerId: number) {
		return this.get<NetworkConnection>(`OnPremPortOpeningRequests/ncdb/${trackerId}`);
	}

	async doReviewal(review: ReviewReason, id: number) {
		return this.patch<PortOpeningRequestSiteToSiteOnPrem>(`OnPremS2SvpnRequests/${id}/review`, review);
	}

	async update(id: number, por: UpdateOnPremS2SRequest) {
		return this.patch<PortOpeningRequestSiteToSiteOnPrem>(`OnPremS2SvpnRequests/${id}`, por);
	}

	async cancel(portOpeningRequestId: number, cancellationModel: CancellationReason) {
		return this.patch<PortOpeningRequestSiteToSiteOnPrem>(
			`OnPremS2SvpnRequests/${portOpeningRequestId}/cancellation`,
			cancellationModel
		);
	}

	async approve(id: number, rejectionModel: RejectionModel) {
		return this.patch<PortOpeningRequestSiteToSiteOnPrem>(`OnPremS2SvpnRequests/${id}/approval`, { Reason: rejectionModel.rejectionReason });
	}

	async reject(portOpeningRequestId: number, rejectionModel: RejectionModel) {
		return this.patch<null>(`OnPremS2SvpnRequests/${portOpeningRequestId}/rejection`, rejectionModel);
	}

	async doComplete(complete: CompletePortOpeningRequestOnPrem, id: number) {
		return this.put<PortOpeningRequestSiteToSiteOnPrem>(`OnPremS2SvpnRequests/${id}/complete`, complete);
	}


}	
